import React from 'react'

import CardWithButtons from 'pages/Dashboard/CardWithButtons'

import AlertIcon from 'pages/shared/Alert/Icon'
import SpeedIcon from '@mui/icons-material/Speed'

import { color } from 'styles/colors'

type Props = {
  sdaMajorAlertCount: number | string
  sdaMinorAlertCount: number | string
  dirtyFilterCount: number | string
  isLoaded: boolean
}

const SdaAlertsCard = ({ sdaMajorAlertCount, sdaMinorAlertCount, dirtyFilterCount, isLoaded }: Props) => {
  const majorSdaButton = {
    text: 'Major SDAs',
    icon: <AlertIcon severity="major-sda" size="32px" />,
    quantity: sdaMajorAlertCount,
    accentColor: color('majorSdaAlert'),
    apptentiveEventName: 'view_sda_major_alerts_customers',
    gaEventName: 'SDA Major Alerts',
    filter: 'sda_major',
    tooltip: 'Total number of "major" SDA alerts identified on registered or opted-in customers\' systems.'
  }

  const minorSdaButton = {
    text: 'Minor SDAs',
    icon: <AlertIcon severity="minor-sda" size="32px" />,
    quantity: sdaMinorAlertCount,
    accentColor: color('minorSdaAlert'),
    hasStripedAccentColor: true,
    apptentiveEventName: 'view_sda_minor_alerts_customers',
    gaEventName: 'SDA Minor Alerts',
    filter: 'sda_minor',
    tooltip: 'Total number of "minor" SDA alerts identified on registered or opted-in customers\' systems.'
  }

  const dirtyFilterButton = {
    text: 'Dirty Air Filters\n SDA.006.03',
    icon: <SpeedIcon style={{ fontSize: '28px' }} />,
    quantity: dirtyFilterCount,
    accentColor: color('dirtyFilter'),
    apptentiveEventName: 'view_dirty_filter_alerts_customers',
    gaEventName: 'Dirty Air Filter Alerts',
    filter: 'dirty_filter',
    tooltip: 'Total number of "dirty air filter" alerts identified on registered or opted-in customers\' systems.'
  }

  return (
    <CardWithButtons
      title="SDAs"
      description="Smart Diagnostics Alerts (SDA) are based on algorithms that run periodically in the cloud and are independent of the alerts triggered within the thermostat or HVAC equipment."
      image="/img/SDA.png"
      buttons={[majorSdaButton, minorSdaButton, dirtyFilterButton]}
      videoKey="sdas"
      isLoaded={isLoaded}
    />
  )
}

export default SdaAlertsCard
